import { allModuleMenus, type NavigationMenuItem } from './navigationMenu';
import { adminHubCategories, administrationMenuItem } from './adminNavigation';

const TITLE_OVERRIDES: Record<string, string> = {
  '/configuraciones/webhooks/ayuda': 'Documentación de webhooks',
};

type PathEntry = { path: string; text: string };

function flattenMenuPaths(items: NavigationMenuItem[]): PathEntry[] {
  const out: PathEntry[] = [];
  for (const item of items) {
    out.push({ path: item.path, text: item.text });
    if (item.subItems?.length) {
      out.push(...flattenMenuPaths(item.subItems));
    }
  }
  return out;
}

/**
 * Título de pantalla legible según la ruta: coincide con el ítem del menú más específico.
 */
export function resolvePageTitleFromPath(pathname: string): string {
  const normalized = (pathname.replace(/\/+$/, '') || '/').trim();
  const override = TITLE_OVERRIDES[normalized];
  if (override) return override;

  const adminEntries: PathEntry[] = [
    { path: administrationMenuItem.path, text: administrationMenuItem.text },
    ...adminHubCategories.flatMap((cat) => cat.items.map((item) => ({ path: item.path, text: item.text }))),
  ];
  const entries = [
    ...flattenMenuPaths(allModuleMenus()),
    ...adminEntries,
  ];
  let best: PathEntry | null = null;
  for (const e of entries) {
    if (normalized === e.path || normalized.startsWith(`${e.path}/`)) {
      if (!best || e.path.length > best.path.length) {
        best = e;
      }
    }
  }
  if (best) {
    return best.text;
  }
  const parts = normalized.split('/').filter(Boolean);
  if (parts.length === 0) {
    return 'Inicio';
  }
  const last = parts[parts.length - 1] ?? '';
  return last
    .split('-')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}
